/* eslint-disable prefer-destructuring */

export const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export const transparentCover = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA5UAAAI+CAMAAAAb2t54AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDQ4OCwgMjAyMC8wNy8xMC0yMjowNjo1MyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjY0MUEzRjkyMzY4MTFFQkE5QjE4RDI0MUM0RjdDMTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjY0MUEzRkEyMzY4MTFFQkE5QjE4RDI0MUM0RjdDMTMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGNjQxQTNGNzIzNjgxMUVCQTlCMThEMjQxQzRGN0MxMyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGNjQxQTNGODIzNjgxMUVCQTlCMThEMjQxQzRGN0MxMyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqWUvVQAAAAGUExURf///wAAAFXC034AAAABdFJOUwBA5thmAAACGElEQVR42uzBMQEAAADCoPVPbQo/oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBrAgwACswAAZSeTB8AAAAASUVORK5CYII='

/* Some utils below original copy from "cloudinary-core" package */

const pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
const rnumnonpx = new RegExp(`^(${pnum})(?!px)[a-z%]+$`, 'i')

const getStyles = (elem) => {
  if (elem.ownerDocument.defaultView.opener) {
    return elem.ownerDocument.defaultView.getComputedStyle(elem, null)
  }
  return window.getComputedStyle(elem, null)
}

const contains = (a, b) => {
  const adown = a.nodeType === 9 ? a.documentElement : a
  const bup = b && b.parentNode
  return a === bup || !!(bup && bup.nodeType === 1 && adown.contains(bup))
}

const domStyle = (elem, name) => {
  if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
    return elem.style[name]
  }
}

const curCSS = (elem, name, cmp) => {
  const rmargin = /^margin/
  let width = null
  let minWidth = null
  let maxWidth = null
  let ret = null
  const { style } = elem
  const computed = cmp || getStyles(elem)
  if (computed) {
    ret = computed.getPropertyValue(name) || computed[name]
  }
  if (computed) {
    if (ret === '' && !contains(elem.ownerDocument, elem)) {
      ret = domStyle(elem, name)
    }
    if (rnumnonpx.test(ret) && rmargin.test(name)) {
      width = style.width
      minWidth = style.minWidth
      maxWidth = style.maxWidth
      // eslint-disable-next-line no-multi-assign
      style.minWidth = style.maxWidth = style.width = ret
      ret = computed.width
      style.width = width
      style.minWidth = minWidth
      style.maxWidth = maxWidth
    }
  }
  if (ret !== undefined) {
    return `${ret}`
  }
  return ret
}

const cssValue = (elem, name, convert, styles) => {
  const val = curCSS(elem, name, styles)
  if (convert) {
    return parseFloat(val)
  }
  return val
}

const augmentWidthOrHeight = (elem, name, extra, isBorderBox, styles) => {
  let j
  let len
  let side
  const sides = name === 'width' ? ['Right', 'Left'] : ['Top', 'Bottom']
  let val = 0
  if (extra === (isBorderBox ? 'border' : 'content')) {
    return 0
  }

  // eslint-disable-next-line no-loops/no-loops
  for (j = 0, len = sides.length; j < len; j++) {
    side = sides[j]
    if (extra === 'margin') {
      val += cssValue(elem, extra + side, true, styles)
    }
    if (isBorderBox) {
      if (extra === 'content') {
        val -= cssValue(elem, `padding${side}`, true, styles)
      }
      if (extra !== 'margin') {
        val -= cssValue(elem, `border${side}Width`, true, styles)
      }
    } else {
      val += cssValue(elem, `padding${side}`, true, styles)
      if (extra !== 'padding') {
        val += cssValue(elem, `border${side}Width`, true, styles)
      }
    }
  }

  return val
}

const getWidthOrHeight = (elem, name, extra) => {
  const styles = getStyles(elem)
  const isBorderBox = cssValue(elem, 'boxSizing', false, styles) === 'border-box'
  let val = name === 'width' ? elem.offsetWidth : elem.offsetHeight
  let valueIsBorderBox = true

  if (val <= 0 || val == null) {
    val = curCSS(elem, name, styles)
    if (val < 0 || val == null) {
      val = elem.style[name]
    }
    if (rnumnonpx.test(val)) {
      return val
    }
    valueIsBorderBox = isBorderBox && val === elem.style[name]
    val = parseFloat(val) || 0
  }

  return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? 'border' : 'content'), valueIsBorderBox, styles)
}

export const width = element => getWidthOrHeight(element, 'width', 'content')
